import React from "react";
import Loading from "../../components/loading/Loading";

function Contact() {
   return <Loading />;
}

export default Contact;
